import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileDown, BarChart3 } from "lucide-react";
import { downloadPdf } from "@/components/HRPhase3Tabs";

export function MyYearSummaryCard() {
  const [years, setYears] = useState([]);
  useEffect(() => { api.get("/payslips").then((r) => setYears([...new Set(r.data.map((s) => (s.pay_date || "").slice(0, 4)).filter(Boolean))].sort().reverse())).catch(() => {}); }, []);
  if (years.length === 0) return null;
  return (
    <Card className="p-5" data-testid="my-year-summary-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h2 className="font-display font-semibold text-base md:text-lg flex items-center gap-2"><BarChart3 className="w-5 h-5 text-primary" /> Yearly earnings summary</h2>
          <p className="text-sm text-muted-foreground mt-1">One page with your gross pay, taxes, deductions and take-home by month — handy for loans, rentals or budgeting.</p>
        </div>
        <div className="flex flex-wrap gap-2">{years.map((y) => <Button key={y} variant="outline" data-testid={`my-year-summary-${y}`} onClick={() => downloadPdf(`/payroll/my-year-summary.pdf?year=${y}`, `${y}_Earnings_Summary.pdf`)}><FileDown className="w-4 h-4 mr-1.5" /> {y} PDF</Button>)}</div>
      </div>
    </Card>
  );
}
